import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2838f92e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2838f92e&prod&lang=sass&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2838f92e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838f92e",
  null
  
)

export default component.exports